<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer002">
<p class="ORIM-Book-Title--Front-Matter-" id="_idParaDest-1"><span class="CharOverride-1">The Man in the Queue</span></p>
<p class="ORIM-Book-Subtitle--Front-Matter-"><span class="CharOverride-1">An Inspector Grant Mystery</span></p>
<p class="ORIM-Author-Name--Front-Matter-"><span class="CharOverride-1">Josephine Tey</span></p>
<p class="ORIM-Author-Name--Front-Matter-"><span><img alt="logo" class="svg" src="image/logo3.jpg"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1-2.vue?3f85f9ee